// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1U0lt","open":"open___3VTxk","link":"link___3J6f3"};